import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import { FiHeadphones , FiMail , FiMapPin } from "react-icons/fi";
import GoogleMapReact from 'google-map-react'; // Aunque comentado, se mantiene el import por si se reactiva
import ContactTwo from "../elements/contact/ContactTwo"; // Asumiendo que este componente también podría necesitar traducción interna
import BrandTwo from "../elements/BrandTwo"; // Asumiendo que este componente también podría necesitar traducción interna
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

// Componente simple para marcador de mapa (actualmente no usado debido al comentario del mapa)
const AnyReactComponent = ({ text }) => <div>{text}</div>;

class Contact extends Component{
    // Propiedades por defecto para el mapa (actualmente no usadas)
    static defaultProps = {
        center: {
            lat: 59.95, // Latitud por defecto
            lng: 30.33  // Longitud por defecto
        },
        zoom: 11 // Nivel de zoom por defecto
    };

    render(){
        return(
            <React.Fragment>
                {/* Configuración del Helmet para el título de la página */}
                <PageHelmet pageTitle='Contacto' />

                {/* Cabecera de la página */}
                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Inicio del Área de Título de Página (Breadcrumb) */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--17" data-black-overlay="6">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    {/* Título principal */}
                                    <h2 className="title theme-gradient">Contacta Con Nosotros</h2>
                                    {/* Subtítulo/Descripción */}
                                    <p>Estamos aquí para ayudarte. Rellena el formulario o utiliza nuestros datos de contacto.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Fin del Área de Título de Página (Breadcrumb) */}


                {/* Inicio del Área Superior de Contacto */}
                <div className="rn-contact-top-area ptb--120 bg_color--5">
                    <div className="container">
                        
                        <div className="row">
                            {/* Inicio de Dirección Individual (Teléfono) */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiHeadphones />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Número de Teléfono</h4>
                                        {/* Número de teléfono proporcionado */}
                                        <p><a href="https://api.whatsapp.com/send?phone=584244560374">0424-4560374</a></p>
                                        {/* <p><a href="tel:+856 325 652 984">+856 325 652 984</a></p> // Se comenta o elimina si solo hay un número */}
                                    </div>
                                </div>
                            </div>
                            {/* Fin de Dirección Individual (Teléfono) */}

                            {/* Inicio de Dirección Individual (Correo) */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt_mobile--50">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMail />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Correo Electrónico</h4>
                                        {/* Correo electrónico proporcionado */}
                                        <p><a href="mailto:escobarmartinez14@gmail.com">escobarmartinez14@gmail.com</a></p>
                                        {/* <p><a href="mailto:example@gmail.com">example@gmail.com</a></p> // Se comenta o elimina si solo hay un correo */}
                                    </div>
                                </div>
                            </div>
                            {/* Fin de Dirección Individual (Correo) */}

                            {/* Inicio de Dirección Individual (Ubicación) */}
                            <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt_md--50 mt_sm--50">
                                <div className="rn-address">
                                    <div className="icon">
                                        <FiMapPin />
                                    </div>
                                    <div className="inner">
                                        <h4 className="title">Ubicación</h4>
                                        {/* Texto de ubicación genérico o placeholder */}
                                        <p>Av. Principal, Ciudad, Estado <br /> Venezuela</p>
                                    </div>
                                </div>
                            </div>
                            {/* Fin de Dirección Individual (Ubicación) */}

                        </div>
                    </div>
                </div>
                {/* Fin del Área Superior de Contacto */}

                {/* Inicio del Área de Página de Contacto (Formulario) */}
                {/* Asegúrate de que el componente ContactTwo también esté traducido si contiene texto visible */}
                <div className="rn-contact-page ptb--120 bg_color--1">
                    <ContactTwo />
                </div>
                {/* Fin del Área de Página de Contacto (Formulario) */}

                {/* Inicio del Mapa de Contacto - COMENTADO */}
                {/*
                <div className="rn-contact-map-area position-relative">
                    <div style={{ height: '650px', width: '100%' }}>
                        <GoogleMapReact
                            // bootstrapURLKeys={{ key: 'TU_API_KEY_DE_Maps' }} // Descomenta y añade tu API Key si reactivas el mapa
                            defaultCenter={this.props.center}
                            defaultZoom={this.props.zoom}
                        >
                            <AnyReactComponent
                                lat={59.955413} // Puedes ajustar a coordenadas reales si lo reactivas
                                lng={30.337844} // Puedes ajustar a coordenadas reales si lo reactivas
                                text="Nuestra Ubicación"
                            />
                        </GoogleMapReact>
                    </div>
                </div>
                */}
                {/* Fin del Mapa de Contacto - COMENTADO */}
                

                {/* Inicio del Área de Marcas */}
                {/* Asegúrate de que el componente BrandTwo también esté traducido si contiene texto visible */}
                <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div>
                {/* Fin del Área de Marcas */}

                {/* Inicio de Botón Volver Arriba */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* Fin de Botón Volver Arriba */}
                
                {/* Pie de página */}
                {/* Asegúrate de que el componente Footer también esté traducido si contiene texto visible */}
                <Footer />
                
            </React.Fragment>
        )
    }
}
export default Contact;